import api from 'utils/apiClient';

export const getDashInfo = (params) => {
  return api.get('/dashboard', {
    headers: {
      Accept: 'application/json',
    },
    params,
  });
};
